/**
 * Step 1 of the Remove flow ("What they lose"): turns the removal-impact payload into the rows
 * the dialog lists. Names are joined for display; counts drive the plural i18n keys
 * (`removeFlow.item.<key>`). Rows with nothing to lose are left out.
 *
 * @param {object} [impact] Body of `getMemberRemovalImpact` (snake_case).
 * @returns {{ key: string, count: number, names?: string }[]}
 */
export const buildRemovalSummary = (impact = {}) => {
  const named = (key, list = []) => (list.length ? { key, count: list.length, names: list.join(', ') } : null);
  const counted = (key, count = 0) => (count > 0 ? { key, count } : null);
  return [
    named('studios', impact.studio_names),
    named('roles', impact.role_names),
    named('groups', impact.group_names),
    counted('directPermissions', impact.direct_permissions),
    counted('resources', impact.shared_resources),
    counted('sessions', impact.active_sessions),
  ].filter(Boolean);
};
